import createReactComponent from '../createReactComponent';
export default createReactComponent('stairs', 'IconStairs', [
  ['path', { d: 'M22 5h-5v5h-5v5h-5v5h-5', key: 'svg-0' }],
]);
